/*global Polyfills, ob1.Ob1Component */

$(function () {
    "use strict";

    const specificChannelCode = document.getElementById("main").dataset.specificChannelCode;

    function polyfill() {
        const {es6Shim, classList} = Polyfills();
        es6Shim();
        classList();
    }

    function manageTabs() {

        const hashConfig = Array.from(
            document.querySelectorAll("nav.ob1-menu-page li.nav-item a:not(.down)")
        ).reduce(function (map, navLink) {
            const hash = navLink.getAttribute("href");
            const panel = document.getElementById(navLink.getAttribute("aria-controls"));
            const filterChipsBar = panel.querySelector(".ob1-filter-chips-bar");
            map.set(hash, {navLink, panel, filterChipsBar});
            return map;
        }, new Map());

        const state = {
            /** ex: "#chainesincluses" **/
            currentHash: Array.from(hashConfig.entries()).find(
                (entry) => entry[1].navLink.parentNode.classList.contains("active")
            )[0]
        };

        const updateView = function () {
            hashConfig.forEach(function (value, hash) {
                const isSelected = hash === state.currentHash;
                value.navLink.setAttribute("aria-expanded", isSelected.toString());
                value.navLink.parentNode.classList.toggle("active", isSelected);
                value.panel.hidden = !isSelected;
                if (isSelected) {
                    value.filterChipsBar.hidden = false;
                    ob1.Ob1Component.get(value.filterChipsBar).FilterChipsBar.resize();
                }
            });
        };

        const onHashChange = function () {
            const loc = window.location;
            const hash = loc.hash;
            const currentHash = state.currentHash;
            if (hash !== currentHash && hashConfig.has(hash)) {
                state.currentHash = hash;
                updateView();
            } else if (hash !== currentHash) {
                const newUrl = loc.origin + loc.pathname + loc.search + currentHash;
                window.history.replaceState({hash: currentHash}, "panel", newUrl);
            }
        };

        const initHash = function () {
            const loc = window.location;
            const hash = loc.hash;
            const currentHash = state.currentHash;
            if (hash !== currentHash && hashConfig.has(hash)) {
                state.currentHash = hash;
            } else if (hash !== currentHash) {
                const newUrl = loc.origin + loc.pathname + loc.search + currentHash;
                window.history.replaceState({hash: currentHash}, "panel", newUrl);
            }
            updateView();
        };

        window.addEventListener("hashchange", onHashChange, false);
        initHash();
    }

    function manageExpands() {
        const channelElemSelector = ".logo-chaine";
        const channelElemActiveClass = "active-expand";
        const clonedChannelInfoSelector = ".infos-chaine.cloned";
        const channelElemList = Array.from(document.querySelectorAll(channelElemSelector));
        const activeChannelBorderClass = "border3";

        function scrollTo(target, durationMs) {
            $("html, body").animate({scrollTop: target.offset().top}, durationMs);
        }

        function findJqActiveChannel() {
            const activeChannel = channelElemList.find(
                (channelElem) => channelElem.classList.contains(channelElemActiveClass)
            );
            return activeChannel === undefined
                ? undefined
                : $(activeChannel);
        }

        function openInfosChaine($channelElem, $channelLogo) {

            const $channelInfo = $channelElem.find(".infos-chaine");
            const $arrow = $channelInfo.find(".arrow");
            const $figure = $channelElem.find("figure:first-child");
            const leftValue = (function () {
                if ($(window).width() >= 960) {
                    const offsetContainer = $channelElem.parents(".row").offset().left;
                    return $figure.offset().left - offsetContainer
                            + $figure.width() / 2 - $arrow.width();
                }
                return $figure.offset().left + $figure.width() / 2 - ($arrow.width() + $arrow.width() / 2);
            }());

            $arrow.css({left: leftValue});

            $channelInfo
                .clone()
                .addClass("cloned")
                .css({
                    top: $channelElem.offset().top
                            - $channelElem.parents(".row").offset().top
                            + $channelElem.outerHeight(true),
                    zIndex: 1
                })
                .insertAfter($channelElem);

            $channelLogo.toggleClass(activeChannelBorderClass);

            const $cloned = $(clonedChannelInfoSelector);

            const initialChannelHeight = $channelElem.outerHeight(true);

            $channelElem.addClass(channelElemActiveClass).css(
                {height: $cloned.outerHeight(true) + initialChannelHeight}
            );

            const $scrollTarget = specificChannelCode ? $cloned : $channelElem;

            $cloned.fadeIn(400, function () {
                scrollTo($scrollTarget, 400);
                $channelElem.css({height: $cloned.outerHeight(true) + initialChannelHeight});
            });
        }

        function closeInfosChaine($activeChannelElem, callback) {

            const $clonedChannelInfo = $(clonedChannelInfoSelector);
            $clonedChannelInfo.fadeOut(400, function () {
                $activeChannelElem.removeAttr("style").removeClass(channelElemActiveClass);
                $clonedChannelInfo.remove();
                $activeChannelElem.find(".clickable-channel").toggleClass(activeChannelBorderClass);
                if (typeof callback === "function") {
                    callback.call();
                }
            });
        }

        function closeAnyChannelInfo() {
            const $activeChannel = findJqActiveChannel();
            if ($activeChannel !== undefined) {
                closeInfosChaine($activeChannel);
            }
        }

        function onClickLogoChaine(jqEvent) {
            const $clickedChannelLogo = $(jqEvent.currentTarget);
            const clickedChannelElem = $clickedChannelLogo.parent(channelElemSelector)[0];
            const $clickedChannelElem = $(clickedChannelElem);
            if (clickedChannelElem.classList.contains(channelElemActiveClass)) {
                closeInfosChaine($clickedChannelElem);
            } else {
                const $activeChannel = findJqActiveChannel();
                if ($activeChannel !== undefined) {
                    // si une autre est ouverte, on la fadeout, puis on l'inactive, puis on ouvre la nouvelle
                    closeInfosChaine($activeChannel, function () {
                        openInfosChaine($clickedChannelElem, $clickedChannelLogo);
                    });
                } else {
                    // sinon, on ouvre la nouvelle tout de suite
                    openInfosChaine($clickedChannelElem, $clickedChannelLogo);
                }
            }
        }

        function onResizeFn(width) {
            return function () {
                const newWidth = $(window).width();
                if (newWidth !== width) {
                    closeAnyChannelInfo();
                    $(window).off("resize").resize(onResizeFn(newWidth));
                }
            };
        }

        $(".clickable-channel").click(onClickLogoChaine);
        $("body").on("click", clonedChannelInfoSelector, function (jqEvent) {
            if (jqEvent.target.tagName !== "A") {
                closeAnyChannelInfo();
            }
        });
        $(window).resize(onResizeFn($(window).width()));
    }

    function manageFilterChipsBar(tabId) {

        const tab = document.getElementById(tabId);
        const channelDivs = tab.querySelectorAll(".logo-chaine");
        const themeDivs = tab.querySelectorAll(".theme");
        const fcbContainer = tab.querySelector(".ob1-filter-chips-bar");
        const filterChipsBar = ob1.Ob1Component.get(fcbContainer).FilterChipsBar;

        // mise en place de la fonction de filtrage au clic d'un élément de chaque filterchips bar
        filterChipsBar.onUpdateValues(function (filters) {

            if (filters.length) { // si au moins un élément de filtrage sélectionné
                // on analyse chaque chaine, si elle a une des propriétés du filtre et on l'affiche ou masque
                channelDivs.forEach(function (channelDiv) {
                        const shouldHideChannel = !filters.some((filter) => channelDiv.classList.contains(filter));
                        channelDiv.classList.toggle("d-none", shouldHideChannel);
                    });
                // Si aucune chaîne dans un theme n'est affichée (sans d-none)
                themeDivs.forEach(function (themeDiv) {
                    const shouldHideTheme = Array.from(themeDiv.querySelectorAll(".logo-chaine"))
                        .every((channelDiv) => channelDiv.classList.contains("d-none"));
                    themeDiv.classList.toggle("d-none", shouldHideTheme);
                });
            } else { // Si aucun filtre = sélection toutes les chaines => donc on réaffiche tous les logos et themes
                channelDivs.forEach(
                    (channelDiv) => channelDiv.classList.remove("d-none")
                );
                themeDivs.forEach(
                    (themeDiv) => themeDiv.classList.remove("d-none")
                );
            }
        });
    }

    function manageScrollToSpecificChannel() {
        if (specificChannelCode) {
            document.getElementById(specificChannelCode).parentNode.firstElementChild.click();
        }
    }

    (function init() {
        polyfill();
        manageTabs();
        manageExpands();
        manageFilterChipsBar("packages");
        manageFilterChipsBar("included");
        manageScrollToSpecificChannel();
    }());
});
